import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/wuxia', label: '热门' },
    { to: '/category/all', label: '分类' },
    { to: '/category/all?sort=rank', label: '排行' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Mobile hamburger */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-50 hover:text-accent-300 transition-colors"
            aria-label="菜单"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>

          {/* Left nav links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`relative text-sm tracking-wide whitespace-nowrap transition-colors duration-300 ${
                  isScrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-foreground-50/80 hover:text-foreground-50'
                }`}
              >
                {link.label}
                {location.pathname === link.to && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-accent-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className={`font-heading text-xl md:text-2xl font-bold tracking-wider whitespace-nowrap transition-colors duration-300 ${
              isScrolled ? 'text-foreground-950' : 'text-foreground-50'
            }`}>
              古风漫画网
            </div>
            <span className={`w-5 h-5 md:w-6 md:h-6 flex items-center justify-center rounded-full border text-[10px] md:text-xs font-bold transition-colors duration-300 ${
              isScrolled
                ? 'border-accent-500 text-accent-500'
                : 'border-accent-300 text-accent-300'
            }`}>
              印
            </span>
          </Link>

          {/* Right actions */}
          <div className="flex items-center gap-3 md:gap-5">
            <Link
              to="/about"
              className={`hidden md:block text-sm whitespace-nowrap transition-colors duration-300 ${
                isScrolled
                  ? 'text-foreground-600 hover:text-primary-500'
                  : 'text-foreground-50/70 hover:text-foreground-50'
              }`}
            >
              关于我们
            </Link>
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-300 cursor-pointer ${
                isScrolled
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                  : 'text-foreground-50/70 hover:text-foreground-50'
              }`}
              aria-label="书签"
            >
              <i className="ri-bookmark-line text-lg"></i>
            </button>
            <Link
              to="/search"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-300 cursor-pointer ${
                isScrolled
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                  : 'text-foreground-50/70 hover:text-foreground-50'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>
            <a
              href="/about"
              className={`hidden md:inline-flex items-center px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                isScrolled
                  ? 'bg-primary-600 text-background-50 hover:bg-primary-700'
                  : 'bg-background-50/90 text-primary-700 hover:bg-background-50'
              }`}
            >
              开始阅读
            </a>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50/98 backdrop-blur-md border-t border-background-200/50 px-4 py-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="block py-3 px-4 text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/about"
            className="block py-3 px-4 text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
          >
            关于我们
          </Link>
        </div>
      </div>
    </nav>
  );
}